import { createContext } from "react";

const DF_OT0040Context = createContext();

export { DF_OT0040Context };
